module.exports = __webpack_public_path__ + "static/img/inca_pruebas.80b94d81.png";